var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--noto",
    width: 32,
    height: 32,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B0B0",
    d: "M8.04 3.32c-2.73.73-3.69 3.34-3.33 6.14c.35 2.81 13.69 110.04 14.04 112.15c.35 2.11 2.46 2.98 4.91 2.81c2.46-.18 4.39-2.11 4.21-4.21C27.7 118.1 13.66 8.41 13.3 6.83s-2.63-4.21-5.26-3.51z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M22.43 117.14c-.74 0-1.39-.55-1.49-1.31L7.12 8.39c-.1-.82.48-1.57 1.3-1.68c.82-.1 1.57.47 1.68 1.3l13.82 107.44c.11.82-.47 1.57-1.3 1.68c-.06.01-.13.01-.19.01z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC1935",
    d: "M20.98 73.61s.21 2.14.85 3.33c.46.87 1.9.31 3.06-.73c1.22-1.1 7.22-5.26 16.64-7.47c11.57-2.7 26.2-7.27 35.25-13.22c12.85-8.44 16.09-15.01 21.91-22.27c5.87-7.34 9.55-10.77 15.18-13.83c5.68-3.09 7.96-3.55 8.69-3.55c.73 0 1.84-1.96.12-2.81c-1.71-.86-14.32-1.71-14.32-1.71L24.28 59.08l-3.3 14.53z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE2C23",
    d: "m12.65 7.92l8.32 65.72s4.31-5.05 13.58-8.32c10.77-3.79 25.33-6 32.68-9.79S84.49 43.9 91.1 36.19c6.61-7.71 11.16-14.41 18.11-19.34c5.87-4.16 13.46-3.79 13.46-3.79s-5.75-4.41-16.28-3.3c-12.17 1.27-27.76 10.76-33.9 9.67C60.75 17.34 59.04 9.14 47.41 6.57C29.08 2.52 12.65 7.92 12.65 7.92z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F5F",
    d: "M25.5 53.08c1.58-.18 3.18-9.79 7.47-17.13s11.01-13.46 13.58-15.18c2.57-1.71 5.63-3.92 1.59-6.12s-11.26-3.92-18.48-3.92c-7 0-8.81.73-9.18 1.59c-.37.86 1.71 23.01 2.45 28.15c.74 5.15 1.47 12.73 2.57 12.61zm34.39-.61c.13.77 11.99-4.41 17.87-11.14c4.79-5.48 6.73-11.87 11.14-16.4c4.41-4.53 8.93-9.06 8.93-9.06s-12.97 1.59-20.19 10.16c-7.22 8.57-9.67 14.07-11.26 16.64c-1.59 2.58-6.61 9.06-6.49 9.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.92f33205.svg";
export { ForwardRef as ReactComponent };